import { render, staticRenderFns } from "./EmptyTranslationList.vue?vue&type=template&id=d3d1ee38"
import script from "./EmptyTranslationList.vue?vue&type=script&lang=js"
export * from "./EmptyTranslationList.vue?vue&type=script&lang=js"
import style0 from "./EmptyTranslationList.vue?vue&type=style&index=0&id=d3d1ee38&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3d1ee38')) {
      api.createRecord('d3d1ee38', component.options)
    } else {
      api.reload('d3d1ee38', component.options)
    }
    module.hot.accept("./EmptyTranslationList.vue?vue&type=template&id=d3d1ee38", function () {
      api.rerender('d3d1ee38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/translations/EmptyTranslationList.vue"
export default component.exports